import { ViewColumnsIcon } from '@heroicons/react/24/outline';
import { useDnD } from '../../context/DnDContext';

const swimlanes = {
  horizontal: {
    width: 600,
    height: 800,
  },
  vertical: {
    width: 800,
    height: 600,
  },
};

const SwimlanePalette = () => {
  const dndContext = useDnD();
  if (!dndContext) {
    throw new Error('useDnD must be used within a DnDProvider');
  }
  const { setData } = dndContext;
  const onDragStart = (
    event: React.DragEvent,
    orientation: 'horizontal' | 'vertical'
  ) => {
    event.dataTransfer.effectAllowed = 'move';
    setData({
      type: 'swimlane',
      orientation,
      width: swimlanes[orientation].width,
      height: swimlanes[orientation].height,
    });
  };

  return (
    <div className="node-palette grid grid-cols-2 grid-rows-1 gap-3">
      {Object.entries(swimlanes).map(([orientation]) => (
        <div
          key={orientation}
          className="p-1 stroke-gray-600 stroke-1 flex justify-center items-center hover:stroke-accent cursor-pointer rounded-md bg-white border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200 ease-in-out"
          draggable
          onDragStart={(event) => {
            onDragStart(event, orientation as 'horizontal' | 'vertical');
          }}
        >
          <ViewColumnsIcon
            className={`size-8 stroke-1 ${
              orientation === 'horizontal' ? 'rotate-90' : ''
            }`}
          />
          <span className="sr-only">{orientation}</span>
        </div>
      ))}
      {/* Add more draggable nodes here */}
    </div>
  );
};

export default SwimlanePalette;
